import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const modelVisualizerTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      xAxisBG: theme.color.surface[2],
      textPrimary: theme.color.text.core['-primary'],
      textSecondary: theme.color.text.core['-secondary'],
      accordion: {
        headerBG: theme.color.dataVis.core['surface-1'],
        headerText: theme.color.text.core['-primary'],
        headerBorder: theme.color.surface[3],
      },
      trendChart: {
        background: theme.color.dataVis.core['surface-1'],
        chartTitle: theme.color.text.core['-primary'],
      },
      areaBG: `${theme.color.dataVis.core['data-tertiary-halftone']}15`,
      criticalArea1BG: `${theme.color.dataVis.core['critical-1-halftone']}15`,
      criticalArea2BG: `${theme.color.dataVis.core['critical-2-halftone']}15`,
      dataLine: theme.color.dataVis.core['data-emphasis'],
      dataLineCritical1: theme.color.dataVis.core['critical-1'],
      dataLineCritical2: theme.color.dataVis.core['critical-2'],
      axisTick: theme.color.dataVis.core['data-tertiary'],
      predictedAreaBG: theme.color.dataVis.qualitative['blue-1'],
      predictedAreaBorder: theme.color.dataVis.qualitative['violet-1'],
      predictedLine: theme.color.dataVis.core['data-emphasis'],
      anomalyLine: theme.color.dataVis.alert['anomaly-3'],
      crosshairLine: theme.color.focus[3],
      dataCircle: theme.color.focus[1],
      exclusionAreaBG: theme.color.dataVis.core['surface-1-halftone-75%'],
      tooltipBG: theme.color.surface[0],
      tooltipText: theme.color.text.core['-primary'],
    },
  ]),
);
